module.exports = __webpack_public_path__ + "Roboto-Bold.e31fcf1885e371e19f57.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Bold.ttf
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Bold.ttf
// module chunks = 3